import { render, staticRenderFns } from "./trtcCall.vue?vue&type=template&id=44b441a8&scoped=true&"
import script from "./trtcCall.vue?vue&type=script&lang=js&"
export * from "./trtcCall.vue?vue&type=script&lang=js&"
import style0 from "./trtcCall.vue?vue&type=style&index=0&id=44b441a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b441a8",
  null
  
)

export default component.exports